import { AcademiesTagsRoutes } from "../screens/academies-tags";
import { AccountsRoutes } from "../screens/accounts";
import { AppBuildNumberRoutes } from "../screens/app-build-number";
import {
	ArchivedDiscountActionsRoutes,
	ActiveDiscountActionsRoutes,
} from "../screens/discount-actions";
import { EducationalOfferRoutes } from "../screens/educational-offer";
import { EmailTemplatesRoutes } from "../screens/email-templates";
import { ExternalLicensesRoutes } from "../screens/external-license-edit";
import { ExternalLicensePoolsRoutes } from "../screens/external-license-pools";
import { FilesRoutes } from "../screens/files/files.routes";
import { GenerateCartLinkRoutes } from "../screens/generate-cart-link";
import { InstructorsRoutes } from "../screens/instructors";
import { LevelDefinitionRoutes } from "../screens/level-definition";
import { LicenseDefinitionsRoutes } from "../screens/license-definitions";
import { LicensesRoutes } from "../screens/licenses";
import { LimitedCartDiscountsRoutes } from "../screens/limited-cart-discounts";
import { MessageDefinitionsRoutes } from "../screens/message-definitions";
import { MessagesRoutes } from "../screens/message-dispatches";
import { OfferCatalogueRoutes } from "../screens/offer-catalogue";
import { OfferFilesRoutes } from "../screens/offer-files";
import { OfferSubscriptionsRoutes } from "../screens/offer-subscriptions";
import { OffersRoutes } from "../screens/offers";
import { OrdersRoutes } from "../screens/orders";
import { PersonalizedNotificationTemplatesRoutes } from "../screens/personalized-notification-templates";
import { ProductsRoutes } from "../screens/products";
import { ReportsRoutes } from "../screens/reports/reports.routes";
import { SettingsRoutes } from "../screens/settings";
import { StagingRoutes } from "../screens/staging";
import { UsersRoutes } from "../screens/users";
import { VideoSourcesRoutes } from "../screens/video-sources/video-sources.routes";

export const AppRoutes = [
	...OffersRoutes,
	...OfferCatalogueRoutes,
	...OfferSubscriptionsRoutes,
	...EducationalOfferRoutes,
	...FilesRoutes,
	...OfferFilesRoutes,
	...UsersRoutes,
	...StagingRoutes,
	...SettingsRoutes,
	...LicensesRoutes,
	...InstructorsRoutes,
	...LevelDefinitionRoutes,
	...EmailTemplatesRoutes,
	...AccountsRoutes,
	...AppBuildNumberRoutes,
	...AcademiesTagsRoutes,
	...OrdersRoutes,
	...PersonalizedNotificationTemplatesRoutes,
	...ProductsRoutes,
	...LimitedCartDiscountsRoutes,
	...GenerateCartLinkRoutes,
	...ActiveDiscountActionsRoutes,
	...ArchivedDiscountActionsRoutes,
	...LicenseDefinitionsRoutes,
	...ExternalLicensePoolsRoutes,
	...ExternalLicensesRoutes,
	...ReportsRoutes,
	...MessagesRoutes,
	...MessageDefinitionsRoutes,
	...VideoSourcesRoutes,
];
